// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import { Field } from 'redux-form'
import { getContactOptions } from '../../PathDb/components/helpers'

import {
  MultiSelectAsync,
  MultiSelectFromState,
} from 'components/Form'

const wrapperClasses = (
  'path-db-search-section-multiselects path-db-search-section display-flex flex-wrap-wrap'
)

const MultiSelects = ({ idRoot, sourceForm }) => (
  <ul className={wrapperClasses}>
    <li className={'path-db-search-input-column display-flex'}>
      <Field
        component={MultiSelectAsync}
        id={`${idRoot}contact-codes`}
        label={'Contact Code'}
        labelKey={'contactCode'}
        name={'contactId'}
        optionsResource={getContactOptions}
        sourceForm={sourceForm}
        valueKey={'contactId'} />
    </li>
    <li className={'path-db-search-input-column'}>
      <Field
        component={MultiSelectFromState}
        id={`${idRoot}band`}
        label={'Band'}
        name={'bandId'}
        labelKey={'bandDescription'}
        targetSet={['regulatorySettings', 'bands']}
        valueKey={'bandId'} />
    </li>
    <li className={'path-db-search-input-column'}>
      <Field
        component={MultiSelectFromState}
        id={`${idRoot}state-region`}
        label={'State'}
        name={'stateId'}
        labelKey={'stateName'}
        targetSet={['regulatorySettings', 'states']}
        valueKey={'stateId'} />
    </li>
    <li className={'path-db-search-input-column'}>
      <Field
        component={MultiSelectFromState}
        id={`${idRoot}site-statuses`}
        label={'Site Status'}
        name={'segmentStatusId'}
        labelKey={'segmentStatus'}
        targetSet={['regulatorySettings', 'segmentStatuses']}
        valueKey={'segmentStatusId'} />
    </li>
  </ul>
)

MultiSelects.propTypes = {
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}

export default MultiSelects
